/**
 * WhatsApp Q&A community link — single source of truth (Feb 2026).
 *
 * Override via build-time env (REACT_APP_WHATSAPP_QA_LINK) if the group
 * has to be rotated (1024-member cap, moderation reset, etc.). Mirrors
 * the backend constant in mail_templates.py / WHATSAPP_QA_LINK env.
 */
export const WHATSAPP_QA_LINK =
  process.env.REACT_APP_WHATSAPP_QA_LINK ||
  "https://chat.whatsapp.com/G9OfkdIPIaP5L1zfd54DBT?s=cl&p=i&ilr=4&amv=2";

export const WHATSAPP_QA_LABEL = "Live Q&A in WhatsApp";
export const WHATSAPP_QA_TAGLINE =
  "Stell deine Fragen direkt — persönlich beantwortet von Pascal.";
